module.exports = __webpack_public_path__ + "img/tn-timeline-main-1.dde87ce3.jpg";